
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[chapterId]/[verseId]/tafsirs",
      function () {
        return require("private-next-pages/[chapterId]/[verseId]/tafsirs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[chapterId]/[verseId]/tafsirs"])
      });
    }
  